/** @jsx jsx */
import { jsx } from '@emotion/react';
import { resizableMediaMigrationNotificationStyle } from './styles';
export var ResizableMediaMigrationNotification = function ResizableMediaMigrationNotification() {
  return jsx("div", {
    "data-testid": "resizable-media-migration-notification",
    css: [resizableMediaMigrationNotificationStyle]
  });
};